<template>
    <LoaderSplash :loaded="loaded">

        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <h1>
                        Manage Clients
                    </h1>

                    <b-button variant="outline-primary mt-1" to="/admin/clients/create">
                        Create New Client
                    </b-button>

                    <b-row>
                        <b-input-group class="col-md-6 mt-5">
                            <b-form-input v-model="filter" placeholder="Type to search" class="mb-0" />

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-row>

                    <b-table class="mt-3"
                             striped
                             hover
                             stacked="md"
                             :filter="filter"
                             :items="clients"
                             :fields="fields">

                        <template slot="actions" slot-scope="row">
                            <b-button class="btn-info mr-2" :to="{ name: 'edit-client', params: { id: row.item.id } }">
                                Edit
                            </b-button>

                            <b-button class="btn-danger" @click="askDeleteItem(row.item)">
                                Delete
                            </b-button>
                        </template>
                    </b-table>

                    <b-modal
                            v-model="show_delete_modal"
                            id="delete-modal"
                            title="Warning"
                            @ok="deleteItem()"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            ok-title="Delete"
                            ok-variant="danger">
                        Are you sure you want to permanently delete this client account?
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>

</template>

<script>
    import clientRespository from "@/repository/clients";

    export default {

        data() {
            return {
                fields: [
                    {
                        key: "name",
                        sortable: true
                    },
                    {
                        key: "email",
                        sortable: true
                    },
                    {
                        key: "active",
                        sortable: true
                    },
                    'actions'
                ],
                show_delete_modal: false,
                client_to_delete: null,
                filter: "",
                loaded:false,
                clients:[]
            }
        },

        mounted(){
            clientRespository.getAll({
                include: 'user'
            })
                .then( response => {
                    response.data.forEach(c => {
                        c.email = c.user.email;

                        this.clients.push(c)
                    });
                    this.loaded = true;
                });
        },

        methods: {
            askDeleteItem(item) {
                this.show_delete_modal = true;
                this.client_to_delete = item;
            },
            
            deleteItem() {
                clientRespository.destroy(this.client_to_delete.id)
                    .then(resp=>{
                        let idx = this.clients.findIndex(client => client.id == this.client_to_delete.id);

                        this.clients.splice(idx, 1);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Client Deleted',
                            text: 'Client successfully deleted.'
                        });
                    })
            }
        }
    }
</script>

<style scoped>

</style>